var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"Taking_Action",attrs:{"aria-label":_vm.$t('strings.takingAction')}},[_c('h2',{style:({ borderBottom: '2px solid ' + _vm.toolkit.color })},[_vm._v(_vm._s(_vm.$t('strings.takingAction')))]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }